<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('sparePartReplacement.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('sparePartReplacement.pageTitle'),
          href: '/admin/v2/spare-part-replacements',
        },
        {
          text: $t('create'),
          active: true,
        },
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal ts-space-y-3">
          <div class="row">
            <label class="required col-form-label col-md-1">
              {{ $t('sparePartReplacement.date') }}
            </label>
            <div class="col-md-4">
              <a-date-picker class="ts-w-full" v-model="model.replacement_date" format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY" :allowClear="false"></a-date-picker>
            </div>
          </div>
          <div class="row">
            <label class="required col-form-label col-md-1">
              {{ $t('sparePartReplacement.mainProduct') }}
            </label>
            <div class="col-md-11">
              <div class="ts-border ts-border-gray-300 ts-p-3 ts-rounded">
                <MainProduct v-model="model" :validate="errors" />
              </div>
            </div>
          </div>
          <div class="row">
            <label class="required col-form-label col-md-1">
              {{ $t('sparePartReplacement.itemDetail') }}
            </label>
            <div class="col-md-11">
              <ItemDetail v-model="model" :validate="errors" ref="details" />
            </div>
          </div>
          <div class="row">
            <label class="col-form-label col-md-1 ts-uppercase">
              {{ $t('sparePartReplacement.remark') }}
            </label>
            <div class="col-md-4">
              <textarea v-model="model.remarks" rows="3" class="form-control"></textarea>
            </div>
            <div class="col-md-7">
              <div class="ts-flex ts-justify-end ts-items-end ts-space-x-3">
                <ts-button @click.prevent="$router.push({ name: 'spare-part-replacement-v2' })">
                  {{ $t('cancel') }}
                </ts-button>
                <ts-button :waiting="loading" @click.prevent="onSavePreview" color="primary" outline>
                  {{ $t('savePrint') }}
                </ts-button>
                <ts-button :waiting="loading" @click.prevent="onSave" color="primary">
                  {{ $t('save') }}
                </ts-button>
              </div>
            </div>
          </div>
        </form>

        <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :zIndex="1020" :footer="null">
          <ts-preview-pdf v-model="loading" :src="src" />
        </a-modal>
      </ts-card-wrapper>
    </ts-card>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>
<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import ItemDetail from './components/item-detail'
import MainProduct from './components/main-product'
import { mapActions } from 'vuex'
export default {
  name: 'replacementCreate',
  components: {
    ItemDetail,
    MainProduct,
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      show_pdf: false,
      src: null,
      model: {
        replacement_date: moment().format('DD-MM-YYYY'),
        product_id: null,
        product_grade: '',
        uom_id: null,
        serial_no: '',
        product_list: [],
        remarks: null,
      },
    }
  },
  computed: {},
  methods: {
    ...mapActions('wholesale/v2/replacement', ['getFormViewModel']),
    async getPreData() {
      this.loading = true
      await this.getFormViewModel({ index: undefined, params: {} })
        .finally(() => {
          this.loading = false
        })
    },
    onSavePreview() {
      this.loading = true
      this.show_pdf = true
      this.src = null
      this.$store
        .dispatch('wholesale/v2/replacement/store',
          Object.assign({}, this.model, {
            is_preview: true
          })
        )
        .then((response) => {
          this.src = response.url
          this.clearInput()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSave() {
      this.loading = true
      this.$store
        .dispatch('wholesale/v2/replacement/store', this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.$router.push({ name: 'spare-part-replacement-v2' })
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInput() {
      this.model.replacement_date = moment().format('DD-MM-YYYY')
      this.model.product_id = null
      this.model.product_grade = ''
      this.model.uom_id = null
      this.model.serial_no = ''
      this.model.product_list = []
      this.model.remarks = null
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getPreData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('wholesale/v2/replacement/CLEAR_SETUP', [])
    next()
  },
}
</script>